/** Drawn-line chrome. Inline SVG only — never emoji or icon fonts. */
const base = { fill: 'none', stroke: 'currentColor', strokeWidth: 2.4, strokeLinecap: 'round', strokeLinejoin: 'round' };

export const DoorIcon = (p) => (
  <svg viewBox="0 0 24 24" {...base} {...p}>
    <path d="M5 21V4.5c0-.8.6-1.5 1.4-1.5H15c.8 0 1.5.7 1.5 1.5V21" />
    <path d="M3 21h18" /><path d="M16.5 8l4-2v15" /><circle cx="12.5" cy="12.5" r=".9" fill="currentColor" />
  </svg>
);
export const WallIcon = (p) => (
  <svg viewBox="0 0 24 24" {...base} {...p}>
    <rect x="3.5" y="4" width="7" height="7" rx="1.5" /><rect x="13.5" y="4" width="7" height="7" rx="1.5" />
    <rect x="3.5" y="14" width="7" height="6.5" rx="1.5" /><path d="M14 17.5l2.2 2.2L20.5 15" />
  </svg>
);
export const PeopleIcon = (p) => (
  <svg viewBox="0 0 24 24" {...base} {...p}>
    <circle cx="9" cy="8" r="3.2" /><path d="M3.5 20c.5-3.5 2.8-5.5 5.5-5.5s5 2 5.5 5.5" />
    <circle cx="17" cy="9.5" r="2.4" /><path d="M15.5 14.5c2.6 0 4.5 1.8 5 5" />
  </svg>
);
export const GrownUpIcon = (p) => (
  <svg viewBox="0 0 24 24" {...base} {...p}>
    <rect x="4" y="10" width="16" height="10.5" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3" /><circle cx="12" cy="15.5" r="1.2" fill="currentColor" />
  </svg>
);
export const CheckIcon = (p) => (
  <svg viewBox="0 0 24 24" {...base} {...p}><path d="M4.5 12.5l4.8 4.8L19.5 6.5" /></svg>
);
export const BackIcon = (p) => (
  <svg viewBox="0 0 24 24" {...base} {...p}><path d="M14.5 5.5L8 12l6.5 6.5" /></svg>
);
export const StarIcon = (p) => (
  <svg viewBox="0 0 24 24" {...base} {...p}><path d="M12 3.5l2.6 5.4 5.9.8-4.3 4.1 1.1 5.9L12 16.9l-5.3 2.8 1.1-5.9-4.3-4.1 5.9-.8z" /></svg>
);
